import React, { useState } from 'react';
import DataTable from '../../../Components/DataTable/DataTable';
import {
  Box,
  CircularProgress,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { palette } from '../../../styles/variables/colors';
import { VisibilityOutlined } from '@mui/icons-material';
import dayjs from 'dayjs';
import { useAuthStore } from '../../../Stores/AuthStore';
import { observer } from 'mobx-react';

const POI_FIELDS = {
  Name: {
    id: 'name',
  },
  Address: {
    id: 'address',
  },
  PoiCategory: {
    id: 'poiCategoryId',
  },
  Organization: {
    id: 'organizationId',
  },
  Actions: {
    id: 'actions',
  },
};

const loader = (
  <Box className="flex justify-center items-center pl-8">
    <CircularProgress size={20} />
  </Box>
);

const ActionButtons = ({
  className,
  item,
  focusedItem,
  handleAction,
  refreshList,
}) => {
  const isFocused = focusedItem?.id === item?.id;
  const [loading, setLoading] = useState(false);

  return (
    <Stack
      className={className}
      direction="row"
      justifyContent="center"
      alignItems="center"
      gap={2}
    >
      {loading ? (
        loader
      ) : (
        <Tooltip
          onClick={() => {
            handleAction({ item });
          }}
          placement="top"
          title={'Προβολή'}
        >
          <VisibilityOutlined
            sx={{
              cursor: 'pointer',
              fontSize: '1.4rem',
              marginLeft: '0.4rem',
              color: isFocused ? palette.info.main : '#333333B2',
            }}
          />
        </Tooltip>
      )}
    </Stack>
  );
};

const PoiTable = ({
  focusedItem,
  isLoading,
  handleAction,
  refreshList,
  pois,
}) => {
  const { isSuperAdmin } = useAuthStore();
  const columns = [
    {
      field: POI_FIELDS?.Name?.id,
      headerName: 'Όνομα σημείου',
      headerClassName: 'table-theme--header',
      cellClassName: 'table-theme--row',
      align: 'left',
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="subtitle1"
          component="div"
          className="flex items-center text-[14px]"
        >
          {params?.row?.[POI_FIELDS?.Name?.id] || '-'}
        </Typography>
      ),
    },
    {
      field: POI_FIELDS?.Organization?.id,
      headerName: 'Οργανισμός',
      headerClassName: 'table-theme--header',
      cellClassName: 'table-theme--row',
      align: 'left',
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="subtitle1"
          component="div"
          className="flex items-center text-[14px]"
        >
          {params?.row?.[POI_FIELDS?.Organization?.id] || '-'}
        </Typography>
      ),
    },
    {
      field: POI_FIELDS?.PoiCategory?.id,
      headerName: 'Κατηγορία',
      headerClassName: 'table-theme--header',
      cellClassName: 'table-theme--row',
      align: 'left',
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="subtitle1"
          component="div"
          className="flex items-center text-[14px]"
        >
          {params?.row?.[POI_FIELDS?.PoiCategory?.id] || '-'}
        </Typography>
      ),
    },
    {
      field: POI_FIELDS?.Address?.id,
      headerName: 'Διεύθυνση',
      headerClassName: 'table-theme--header',
      cellClassName: 'table-theme--row',
      align: 'left',
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      flex: 2,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="subtitle1"
          component="div"
          className="flex items-center text-[14px]"
        >
          {params?.row?.[POI_FIELDS?.Address?.id] ?? '-'}
        </Typography>
      ),
    },
    {
      field: POI_FIELDS?.Actions?.id,
      headerName: 'Ενέργειες',
      headerClassName: 'table-theme--header',
      cellClassName: 'table-theme--row',
      align: 'left',
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      renderCell: (params) => (
        <ActionButtons
          focusedItem={focusedItem}
          item={params?.row}
          handleAction={handleAction}
          className="ml-1"
          refreshList={refreshList}
        />
      ),
    },
  ].filter((column) =>
    isSuperAdmin ? true : column.field !== POI_FIELDS?.Organization?.id
  );

  return (
    <>
      <>
        {!!pois?.length && (
          <DataTable
            columns={columns}
            rows={pois || []}
            loading={isLoading}
            backgroundColor="#f9f9f9"
          />
        )}
      </>
      {!pois?.length && (
        <div className="flex justify-center items-center p-10">
          Δεν υπάρχουν αποτελέσματα
        </div>
      )}
    </>
  );
};

export default observer(PoiTable);
